import gql from "graphql-tag";

export const gameHasPlayedFields = gql`
  fragment GameHasPlayedFields on Game {
    hasPlayed
  }
`;

export const gameFields = gql`
  fragment GameFields on Game {
    id
    title
    description
    category
    type
    status
    metadata
    developer
    publisher
    orientation
    hasBattle
    ageRatings {
      system
      rating
      contentDescriptors
    }
  }
`;

export const gameFieldsAaa = gql`
  fragment GameFieldsAaa on Game {
    id
    title
    description
    category
    type
    status
    metadata
    developer
    publisher
    orientation
    ageRatings {
      system
      rating
      contentDescriptors
    }
  }
`;
